import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image/withIEPolyfill';
import { ToolCardContainer } from './styles';

const ToolCard = ({ title, description, featureImage, cardBackColor, width, ...otherProps }) => {
  return (
    <ToolCardContainer background={cardBackColor} width={width} bordered={false}>
      <div className="tool-card--container">
        <div className="tool-card--image-container">
          <Img
            className="tool-card--image"
            fluid={featureImage.fluid}
            objectPosition="100% 50%"
            alt={title}
          />
        </div>
        <div className="tool-card--body-container">
          <div className="tool-card--content-container">
            <h2 className="tool-card--title" dangerouslySetInnerHTML={{ __html: title }}></h2>
            {description && <p className="tool-card--description">{description}</p>}
          </div>
        </div>
      </div>
    </ToolCardContainer>
  );
};

ToolCard.propTypes = {
  textAlign: PropTypes.string, // 'left', 'center', 'right', 'justify'
  width: PropTypes.string,
  buttonTitle: PropTypes.string,
  linkTo: PropTypes.string,
};

ToolCard.defaultProps = {
  textAlign: 'left',
  width: '100%',
};

export default ToolCard;
